const About=()=>{
    return (
        <>
             <div className='page-header'>
      <h2 className='page-title'>About Us</h2>
      </div>
         <div className="bg-light-2 about mt-5 pt-5">
        <div className="container about-container">
            <div className="row">
                <div className="col-md-6 about-text">
<p className="text-muted lead"> 
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. 

</p>
                </div>
                <div className="col-md-6 about-img">
                    <img src="https://media.istockphoto.com/id/1314987155/photo/modern-golden-bracelets-and-ring-on-white-and-blue-background-with-copy-space.jpg?s=612x612&w=0&k=20&c=qF_aT8dD83Vi7IgZvZJZUzWSUInwFDCdr7fmO9RhHtQ=" className="img-fluid" alt="about_banner"/>
                </div>
            </div>
        </div>
    </div>
    <div className="container about-container mt-5 mb-5">
        <div className="row">
                    <div className="col-md-6">
                    <img src="https://www.zilliondesigns.com/blog/wp-content/uploads/Perfect-Ecommerce-Sales-Banner.jpg" alt="about"   className="img-fluid"/>
                    </div>
                 <div className="col-md-6 about-text">
                   <p className="text-muted lead">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                   </div>
                   <div>
                
            </div>
        </div>
    </div>
 
    </>

        )

}
export default About;